<template>
    <kgr-filter-container>
        <div class="kgr-grid kgr-grid--gutters kgr-row">
            <div class="kgr-grid__cell">
                <kgr-dropdown
                    :value="value.kindergartenSource"
                    :options="kindergartens"
                    display="name"
                    :label="$t('duplication.source_kindergarten')"
                    @post-input="onKindergartenSourceInput($event)"
                />
            </div>
            <div class="kgr-grid__cell">
                <kgr-dropdown
                    :value="value.kindergartenTarget"
                    :options="kindergartenTargets"
                    display="name"
                    :label="$t('duplication.target_kindergarten')"
                    @post-input="onKindergartenTargetInput($event)"
                />
            </div>
        </div>
        <kgr-checkbox-group
            :value="value.filters"
            :options="filterOptions"
            :label-prefix="labelPrefix"
            inline
            @post-input="onFiltersInput($event)"
        />
    </kgr-filter-container>
</template>

<script>
import CheckboxGroup from '../common/form/checkbox/CheckboxGroup.vue';
import Dropdown from '../common/form/select/Dropdown.vue';
import FilterContainer from '../common/FilterContainer.vue';

export default {
    components: {
        'kgr-filter-container': FilterContainer,
        'kgr-checkbox-group': CheckboxGroup,
        'kgr-dropdown': Dropdown,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        labelPrefix: {
            type: String,
            required: true,
        },
        filterOptions: {
            type: Array,
            required: true,
        },
        kindergartens: {
            type: Array,
            required: true,
        },
    },
    computed: {
        kindergartenTargets() {
            if (this.value.kindergartenSource === null) {
                return this.kindergartens;
            }

            return this.kindergartens.filter((kindergarten) => kindergarten.id !== this.value.kindergartenSource.id);
        },
    },
    methods: {
        onKindergartenSourceInput(event) {
            this.$emit('kindergartenSourceChanged', event);

            if (this.value.kindergartenTarget === null) {
                this.emit(event, null, this.value.filters);
                return;
            }

            if (event === null) {
                this.emit(null, this.value.kindergartenTarget, this.value.filters);
                return;
            }

            if (event.id === this.value.kindergartenTarget.id) {
                this.emit(event, null, this.value.filters);
            } else {
                this.emit(event, this.value.kindergartenTarget, this.value.filters);
            }
        },
        onKindergartenTargetInput(event) {
            this.$emit('kindergartenTargetChanged', event);
            this.emit(this.value.kindergartenSource, event, this.value.filters);
        },
        onFiltersInput(event) {
            this.emit(this.value.kindergartenSource, this.value.kindergartenTarget, event);
        },
        emit(kindergartenSource, kindergartenTarget, filters) {
            const data = { kindergartenSource, kindergartenTarget, filters };
            this.$emit('input', data);
            this.$nextTick(() => {
                this.$emit('post-input', data);
            });
        },
    },
};
</script>
